import {IntercomDevice} from './intercomDevice';

/**
 *
 * @export
 * @interface AccessGroup
 */
export interface AccessGroup {
  /**
   * 创建日期
   * @type {string}
   * @memberof AccessGroup
   */
  createdAt?: string;
  /**
   * 描述信息
   * @type {string}
   * @memberof AccessGroup
   */
  description?: string;
  /**
   * 设备数量
   * @type {number}
   * @memberof AccessGroup
   */
  deviceCount?: number;
  /**
   *
   * @type {string}
   * @memberof AccessGroup
   */
  id?: string;
  /**
   * 设备信息
   * @type {Array<AccessGroupIntercom>}
   * @memberof AccessGroup
   */
  intercoms?: Array<AccessGroupIntercom>;
  /**
   * 权限组名字
   * @type {string}
   * @memberof AccessGroup
   */
  name?: string;
  /**
   * 所属组织
   * @type {string}
   * @memberof AccessGroup
   */
  orgId?: string;
  /**
   * 租户数量
   * @type {number}
   * @memberof AccessGroup
   */
  tenantCount?: number;
  /**
   * 修改日期
   * @type {string}
   * @memberof AccessGroup
   */
  updatedAt?: string;
}
/**
 *
 * @export
 * @interface AccessGroupCreateReq
 */
export interface AccessGroupCreateReq {
  /**
   *
   * @type {AccessGroup}
   * @memberof AccessGroupCreateReq
   */
  accessGroup?: AccessGroup;
  /**
   *
   * @type {Array<AccessGroupIntercom>}
   * @memberof AccessGroupCreateReq
   */
  intercoms?: Array<AccessGroupIntercom>;
}
/**
 *
 * @export
 * @interface AccessGroupIntercom
 */
export interface AccessGroupIntercom {
  /**
   *
   * @type {AccessGroup}
   * @memberof AccessGroupIntercom
   */
  accessGroup?: AccessGroup;
  /**
   *
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  accessGroupId?: string;
  /**
   *
   * @type {boolean}
   * @memberof AccessGroupIntercom
   */
  allTimeAccess?: boolean;
  /**
   * 创建日期
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  id?: string;
  /**
   *
   * @type {IntercomDevice}
   * @memberof AccessGroupIntercom
   */
  intercomDevice?: IntercomDevice;
  /**
   *
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  intercomDeviceId?: string;
  /**
   * 12:00 PM
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  timeEnd?: string;
  /**
   * 12:00 AM
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  timeStart?: string;
  /**
   * 修改日期
   * @type {string}
   * @memberof AccessGroupIntercom
   */
  updatedAt?: string;
  /**
   *
   * @type {boolean}
   * @memberof AccessGroupIntercom
   */
  virtualKeyEnabled?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof AccessGroupIntercom
   */
  weekdays?: Array<AccessGroupIntercomWeekdaysEnum>;
}

export const AccessGroupIntercomWeekdaysEnum = {
  Unspecified: 'WEEKDAY_UNSPECIFIED',
  Monday: 'WEEKDAY_MONDAY',
  Tuesday: 'WEEKDAY_TUESDAY',
  Wednesday: 'WEEKDAY_WEDNESDAY',
  Thursday: 'WEEKDAY_THURSDAY',
  Friday: 'WEEKDAY_FRIDAY',
  Saturday: 'WEEKDAY_SATURDAY',
  Sunday: 'WEEKDAY_SUNDAY',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AccessGroupIntercomWeekdaysEnum =
  (typeof AccessGroupIntercomWeekdaysEnum)[keyof typeof AccessGroupIntercomWeekdaysEnum];

/**
 *
 * @export
 * @interface AccessGroupTenantReq
 */
export interface AccessGroupTenantReq {
  /**
   *
   * @type {string}
   * @memberof AccessGroupTenantReq
   */
  accessGroupId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AccessGroupTenantReq
   */
  tenantId?: Array<string>;
}
/**
 *
 * @export
 * @interface AccessGroups
 */
export interface AccessGroups {
  /**
   *
   * @type {Array<AccessGroup>}
   * @memberof AccessGroups
   */
  accessGroups?: Array<AccessGroup>;
  /**
   *
   * @type {number}
   * @memberof AccessGroups
   */
  total?: number;
}

/**
 * 添加单个用户到权限组的请求
 * @export
 * @interface AccessGroupOrgUserReq
 */
export interface AccessGroupOrgUserReq {
  /**
   * 权限组ID
   * @type {string}
   * @memberof AccessGroupOrgUserReq
   */
  accessGroupId?: string;
  /**
   * 用户ID
   * @type {string}
   * @memberof AccessGroupOrgUserReq
   */
  userId?: string;
}

/**
 * 添加多个用户到权限组的请求
 * @export
 * @interface AccessGroupOrgUsersReq
 */
export interface AccessGroupOrgUsersReq {
  /**
   * 权限组ID
   * @type {string}
   * @memberof AccessGroupOrgUsersReq
   */
  accessGroupId?: string;
  /**
   * 用户ID列表
   * @type {Array<string>}
   * @memberof AccessGroupOrgUsersReq
   */
  userIds?: Array<string>;
}

/**
 * 从权限组删除用户的请求
 * @export
 * @interface AccessGroupOrgUsersDeleteReq
 */
export interface AccessGroupOrgUsersDeleteReq {
  /**
   * 权限组ID
   * @type {string}
   * @memberof AccessGroupOrgUsersDeleteReq
   */
  accessGroupId?: string;
  /**
   * 用户ID列表
   * @type {Array<string>}
   * @memberof AccessGroupOrgUsersDeleteReq
   */
  userIds?: Array<string>;
}

/**
 * 权限组用户角色信息
 * @export
 * @interface AccessGroupUserRole
 */
export interface AccessGroupUserRole {
  /**
   * 角色ID
   * @type {string}
   * @memberof AccessGroupUserRole
   */
  id?: string;

  /**
   * 角色名称
   * @type {string}
   * @memberof AccessGroupUserRole
   */
  name?: string;

  /**
   * 角色描述
   * @type {string}
   * @memberof AccessGroupUserRole
   */
  description?: string;
}

/**
 * 组织信息
 * @export
 * @interface UserOrganization
 */
export interface UserOrganization {
  /**
   * 组织用户关系ID
   * @type {string}
   * @memberof UserOrganization
   */
  id?: string;

  /**
   * 组织ID
   * @type {string}
   * @memberof UserOrganization
   */
  organizationId?: string;

  /**
   * 组织名称
   * @type {string}
   * @memberof UserOrganization
   */
  organizationName?: string;

  /**
   * 状态
   * @type {string}
   * @memberof UserOrganization
   */
  status?: string;

  /**
   * 邮箱
   * @type {string}
   * @memberof UserOrganization
   */
  email?: string;

  /**
   * 名称
   * @type {string}
   * @memberof UserOrganization
   */
  name?: string;

  /**
   * 角色
   * @type {AccessGroupUserRole | null}
   * @memberof UserOrganization
   */
  role?: AccessGroupUserRole | null;
}

/**
 * 用户详细信息
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
  /**
   * 是否需要更改密码
   * @type {boolean}
   * @memberof UserDetail
   */
  needChangePassword?: boolean;
}

/**
 * 权限组中的组织用户
 * @export
 * @interface AccessGroupOrgUser
 */
export interface AccessGroupOrgUser {
  /**
   * 用户ID
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  id?: string;

  /**
   * 用户邮箱
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  email?: string;

  /**
   * 用户状态
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  status?: string;

  /**
   * 创建时间
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  createdAt?: string;

  /**
   * 更新时间
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  updatedAt?: string;

  /**
   * 用户昵称
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  nickname?: string;

  /**
   * 用户名字
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  firstName?: string;

  /**
   * 用户姓氏
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  lastName?: string;

  /**
   * 最后登录时间
   * @type {string}
   * @memberof AccessGroupOrgUser
   */
  lastLogin?: string;

  /**
   * 用户详细信息
   * @type {UserDetail}
   * @memberof AccessGroupOrgUser
   */
  detail?: UserDetail;

  /**
   * 用户所属组织列表
   * @type {Array<UserOrganization>}
   * @memberof AccessGroupOrgUser
   */
  organizations?: Array<UserOrganization>;

  /**
   * 用户角色列表
   * @type {Array<AccessGroupUserRole>}
   * @memberof AccessGroupOrgUser
   */
  roles?: Array<AccessGroupUserRole>;
}

/**
 * 权限组组织用户列表响应
 * @export
 * @interface AccessGroupOrgUsers
 */
export interface AccessGroupOrgUsers {
  /**
   * 用户列表
   * @type {Array<AccessGroupOrgUser>}
   * @memberof AccessGroupOrgUsers
   */
  users?: Array<AccessGroupOrgUser>;

  /**
   * 总数
   * @type {number}
   * @memberof AccessGroupOrgUsers
   */
  total?: number;
}
